function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
}
module.exports = _isNumber;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_isNumber.js
// module id = 4212
// module chunks = 168707334958949